"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "resiutta": {
    "e32d4065": [{
      "hkey": "b5b64b57",
      "slug": "povici",
      "name": "Povici",
      "primary": true,
      "skipSearch": false
    }],
    "povici-di-sopra": [{
      "hkey": "b5b64b57",
      "slug": "povici",
      "name": "Povici",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "resiutta"
    }],
    "55173785": [{
      "hkey": "b5b64b57",
      "slug": "povici",
      "name": "Povici",
      "primary": true,
      "skipSearch": false
    }],
    "povici-di-sotto": [{
      "hkey": "b5b64b57",
      "slug": "povici",
      "name": "Povici",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "resiutta"
    }]
  }
};
exports["default"] = _default;